import { mapState } from 'vuex';

export default {
  name: 'EeiregInvalidClients',
  props: {
    materialGroup: {
      default: null,
      type: String
    },
    isModal: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      loading: false,
      updating: false,
      fromPeriod: null,
      tableData: null
    }
  },
  computed: {
    ...mapState(['config']),
    toPeriod () {
      return this.BasicHelper.getNextDatePeriod(this.fromPeriod);
    },
    componentName () {
      if (this.isModal) {
        return 'b-modal';
      }
      return 'div';
    },
    requestPath () {
      return 'eeireg/invalid-clients/' + this.materialGroup + '/' + this.fromPeriod;
    },
    tableHeaders () {
      const headers = [
        { key: 'title', label: this.$t('eeireg.invalid-clients.name'), localFilter: true },
        { key: 'client.name', label: this.$t('client.name'), type: 'routelink', routeTo: 'menu.client.edit', params: { clientApiId: 'client.api_id' }, localFilter: true },
        { key: 'client.registryNumber', label: this.$t('client.registryNumber'), type: 'slot', slotcode: 'registryNumber', localFilter: true, searchFunc: this.getSearchClientRegistry },
        { key: 'registryNumber', label: this.$t('eeireg.invalid-clients.registryNumber'), localFilter: true },
        { key: 'originalRegistryNumber', label: this.$t('eeireg.invalid-clients.originalRegistryNumber'), localFilter: true },
        { key: 'info', label: this.$t('eeireg.invalid-clients.info'), format: 'formatFunc', funcs: [this.getErrorInfo], classFuncs: [null] },
        { key: 'contracts', label: this.$t('client.section.contracts'), type: 'slot', slotcode: 'contracts' },
        { key: 'actions', label: '' }
      ];
      return headers;
    },
    title () {
      return this.$t('eeireg.invalid-clients.title') + ': ' + this.BasicHelper.getDatePeriodRangeFormatted(this.fromPeriod, this.toPeriod);
    }
  },
  methods: {
    setData (period) {
      this.fromPeriod = period;
      this.activeInfo = null;
      this.sentInfo = null;
      this.getTableData();
      if (this.isModal) {
        this.$refs['modal-window'].show();
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    },
    getTableData () {
      if (this.fromPeriod) {
        this.loading = true;
        const self = this;
        this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_GET, [], function (response) {
          if (response.data) {
            self.tableData = response.data;
          }
          self.loading = false;
        })
      }
    },
    getErrorInfo (val, item) {
      if (item.item.multipleClients == 1) {
        return this.$t('eeireg.invalid-clients.error.multiple-clients');
      }
      if (item.item.client) {
        return this.$t('eeireg.invalid-clients.error.no-contract');
      }
      return this.$t('eeireg.invalid-clients.error.not-found');
    },
    getSearchClientRegistry (text, el) {
      if (el.client && el.clientregistryNumberEeireg) {
        text += ' ' + el.client.registryNumberEeireg;
      }
      return text;
    }
  }
}
